import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Success() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [data, setData] = useState(null);

  useEffect(() => {
    if (sessionId) {
      axios.get(`/api/donations/session/${sessionId}`)
        .then(r => setData(r.data))
        .catch(() => {});
    }
  }, [sessionId]);

  const donation = data?.donation;

  return (
    <>
      <Navbar />
      <section className="min-vh-100 d-flex align-items-center py-5" style={{ background: 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 text-center">
              <div className="card border-0 shadow-lg rounded-4 p-5">
                <div className="mb-4" style={{ fontSize: '5rem', animation: 'fadeInUp .5s ease' }}>🎉</div>
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4 mx-auto"
                  style={{ width: 72, height: 72, background: 'linear-gradient(135deg, #22c55e, #16a34a)', color: '#fff', fontSize: '2rem' }}
                >
                  <i className="bi bi-check-lg" />
                </div>
                <h2 className="fw-bold mb-1 text-success">{t('success.title')}</h2>
                <p className="text-muted mb-4">{t('success.subtitle')}</p>
                <p className="mb-4" style={{ color: '#555', lineHeight: 1.8 }}>{t('success.message')}</p>

                {donation && (
                  <div className="p-4 rounded-3 mb-4 text-start"
                    style={{ background: 'rgba(25,135,84,.05)', border: '1px solid rgba(25,135,84,.15)' }}>
                    <div className="d-flex justify-content-between py-2 border-bottom">
                      <span className="text-muted">{donation.name}</span>
                      <strong>¥{Number(donation.amount).toLocaleString()}</strong>
                    </div>
                    {donation.receipt_number && (
                      <div className="d-flex justify-content-between pt-2">
                        <span className="text-muted small">Receipt</span>
                        <span className="small fw-semibold text-success">{donation.receipt_number}</span>
                      </div>
                    )}
                  </div>
                )}

                <Link to="/" className="btn btn-donate px-5 py-3 fs-5">
                  <i className="bi bi-house-fill me-2" />
                  {t('success.homeBtn')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
